import { render } from "./StandingsThurA.vue?vue&type=template&id=52e99274&scoped=true"
import script from "./StandingsThurA.vue?vue&type=script&scoped=true&lang=js"
export * from "./StandingsThurA.vue?vue&type=script&scoped=true&lang=js"

import "./StandingsThurA.vue?vue&type=style&index=0&id=52e99274&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e99274"]])

export default __exports__